import { type Payable } from '@spendesk/bookkeeping-core-types';

import {
  type AnalyticalFieldAssociationAutomation,
  type ExpenseAccountAutomation,
  type VatAccountAutomation,
} from '../../models';

export function shouldPayableRuleAutomationExistsCalloutBeDisplayed({
  payable,
  currentValue,
  ruleBasedAutomation,
}: {
  payable: Pick<Payable, 'version'>;
  currentValue: string | undefined;
  ruleBasedAutomation:
    | ExpenseAccountAutomation
    | VatAccountAutomation
    | AnalyticalFieldAssociationAutomation;
}): boolean {
  const isFirstVersion = payable.version === 1;
  if (!isFirstVersion) {
    return false;
  }

  if (ruleBasedAutomation.isAppliedOnPayable) {
    return false;
  }

  if (ruleBasedAutomation.kind !== 'ruleBased') {
    return false;
  }

  return ruleBasedAutomation.output !== currentValue;
}
